export default {

    BATHTUB: {
        stepOne: {
            menu: {
                title: 'Su misura',
                body:  {
                    len: '2',
                    1:   'Dimensioni di base:',
                    2:   'Dimensioni effettive:',
                },
            },
            form: {
                title:  'Dimensioni effettive',
                width:  'LARGHEZZA (CM)',
                length: 'LUNGHEZZA (CM)',
                to:     'a',
            },

        },
        stepTwo: {
            menu: {
                title: 'Bordi rialzati',
                body:  {
                    len:   '2',
                    1:     'Codice bordi rialzati',
                    2:     'Bordo rialzato parziale',
                    back:  'in fondo',
                    front: 'davanti',
                    left:  'a sinistra',
                    right: 'a destra',
                },
            },
            form: {
                title:    'Bordo rialzatoncode:',
                checkbox: 'Bordo rialzato parziale',
                left:     'A sinistra',
                right:    'A destra',
                back:     'In fondo',
                front:    'Davanti',
            },
            summary: {
                Z23: {
                    '1':  "Bordo rialzato in fondo",
                    '02': "Bordo rialzato parziale in fondo a sinistra",
                    '03': "Bordo rialzato parziale in fondo a destra"
                },
                Z45: {
                    '1':  "Bordo rialzato a destra",
                    '04': "Bordo rialzato parziale a destra in fondo",
                    '05': "Bordo rialzato parziale a destra davanti"
                },
                Z67: {
                    '1':  "Bordo rialzato davanti",
                    '06': "Bordo rialzato parziale davanti a destra",
                    '07': "Bordo rialzato parziale davanti a sinistra"
                },
                Z81: {
                    '1':  "Bordo rialzato a sinistra",
                    '01': "Bordo rialzato parziale a sinistra in fondo",
                    '08': "Bordo rialzato parziale a sinistra davanti"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Versioni angolari',
                title2: 'Versione angolare',
                body:  {
                    len: '1',
                    1:   'Angoli definti',
                    EA12: 'In fondo a sinistra',
                    EA34: 'In fondo a destra',
                    EA78: 'Davanti a sinistra',
                    EA56: 'Davanti a destra',
                },
            },
            form: {
                back_left:   'In fondo a sinistra',
                back_right:  'In fondo a destra',
                front_left:  'Davanti a sinistra',
                front_right: 'Davanti a destra',
            },

        },
        stepFour: {
            menu: {
                title: 'Fori per rubinetteria',
                body:  {
                    len: '1',
                    1:   'Foro per miscelatore monocomando',
                    2:   'Davanti a destra',
                    L1:  'Miscelatore monocomando',
                    L2:  'Foro rotondo',
                    AT:  'Foro per rubinetteria su misura',
                },
            },
            form: {
                armatur_type:          'Tipo di ',
                position:              'Position',
                checkbox:              'Rivestimento ridotto',
                L1:                    'Miscelatore monocomando',
                L2:                    'Foro rotondo',
                AT:                    'Foro per rubinetteria su misura',
                L2M:                   'mm',
                armatur:               'RUBINETTERIA',
                armatur_placeholder:   'Fabbricante e tipo',
                anmerkung:             'ANNOTAZIONE',
                anmerkung_placeholder: 'Esempio',
                drawing_upload:        'CARICARE DISEGNO',
                drawing_necessary:     'Disegno obbligatorio',
            },

        },
        stepFive: {
            menu: {
                title: 'Guarnizioni',
                body:  {
                    len:  '1',
                    1:    'presente',
                    SPV:  'SPLASH',
                    ALGV: 'Scarico',
                },
            },
            form: {
                title:      'TRATTAMENTO DELLA SUPERFICIE',
                text_field: {
                    placeholder: 'Positione speciale',
                },
                SPV:     'Guarnizione Schmidlin SPLASH',
                ALGV:    'Guarnizione di scarico',
                options: [
                    'Nome di colore',
                ],
                checkbox: {
                    label1: 'CLEANEFFECT',
                    label2: 'CLEANEFFECT',
                },
            },

        },
        stepSix: {
            menu: {
                title: 'Maniglie',
                body:  {
                    len: '1',
                    1:   'Presente',
                    GR:  'Maniglio',
                },
            },
            form: {
                GR:         'Con maniglie',
                text_field: {
                    placeholder: 'Posizione su richiesta speciale',
                },
            },

        },
        stepSeven: {
            menu: {
                title: 'Sistemi d\'idromassaggio',
                body:  {
                    len:         '2',
                    whirlsystem: 'Sistema d\'idromassaggio',
                    TA:          'Indicatore di temperatura',
                    WM:          'Rivelatore di acqua',
                    FL2:         'Cromoterapia',
                    SW2:         'Fari subacquei',
                    ALG:         'Guarnitura di scarico'
                },
            },
            form: {
                armatur:  'Guarnizioni',
                option: 'OPZIONI',
                TA:     'Indicatore di temperatura',
                WM:     'Rivelatore di acqua',
                FL2:    'Cromoterapia',
                SW2:    'Fari subacquei',
                system: 'Con sistema d\'idromassaggio',
            },

        },
        stepEight: {
            menu: {
                title: 'Sistema audio',
                body:  {
                    len:         '1',
                    1:           'Sistema audio',
                    soundsystem: 'Sistema audio',
                },
            },
            form: {
                system: 'Con sistema audio',
            },
        },

        stepNine: {
            menu: {
                title: 'Superficie',
                title2: 'Colore',
                body:  {
                    len:       '2',
                    1:         'bianco matto',
                    2:         'CLEANEFFECT, GLASUR PLUS',
                    antigliss: 'CLEANEFFECT',
                    glassur:   'GLASUR PLUS',
                },
            },
            form: {
                ober:           'TRATTAMENTO DELLA SUPERFICIE',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'CLEANEFFECT',
                txtPlaceholder: 'Commenti per richiesta speciale',
                colorName:      'Nome di colore',
                options:        [
                    'Nome di colore',
                ],
            },

        },


    },

    DWDF: {
        stepOne: {
            menu: {
                title: 'Su misura',
                body:  {
                    len: '2',
                    1:   'Dimensioni di base:',
                    2:   'Dimensioni effettive:',
                },
            },
            form: {
                title:  'Dimensioni di base',
                width:  'LARGHEZZA (CM)',
                length: 'LUNGHEZZA (CM)',
                to:     'a',
            },

        },
        stepTwo: {
            menu: {
                title: 'Bordi rialzati',
                body:  {
                    len:   '2',
                    1:     'Codice bordi rialzati',
                    2:     'Bordo rialzato parziale',
                    back:  'in fondo',
                    front: 'davanti',
                    left:  'a sinistra',
                    right: 'a destra',
                },
            },
            form: {
                title:    'Codice bordi rialzati:',
                checkbox: 'Bordo rialzato parziale',
                left:     'A sinistra',
                right:    'A destra',
                back:     'In fondo',
                front:    'Davanti',
            },
            summary: {
                Z23: {
                    '1':  "Bordo rialzato in fondo",
                    '02': "Bordo rialzato parziale in fondo a sinistra",
                    '03': "Bordo rialzato parziale in fondo a destra"
                },
                Z45: {
                    '1':  "Bordo rialzato a destra",
                    '04': "Bordo rialzato parziale a destra in fondo",
                    '05': "Bordo rialzato parziale a destra davanti"
                },
                Z67: {
                    '1':  "Bordo rialzato davanti",
                    '06': "Bordo rialzato parziale davanti a destra",
                    '07': "Bordo rialzato parziale davanti a sinistra"
                },
                Z81: {
                    '1':  "Bordo rialzato a sinistra",
                    '01': "Bordo rialzato parziale a sinistra in fondo",
                    '08': "Bordo rialzato parziale a sinistra davanti"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Versioni angolari',
                title2: 'Versione angolare',
                body:  {
                    len: '1',
                    1:   'Angoli definiti',
                    EA12: 'In fondo a sinistra',
                    EA34: 'In fondo a destra',
                    EA78: 'Davanti a sinistra',
                    EA56: 'Davanti a destra',
                },
            },
            form: {
                back_left:   'In fondo A sinistra',
                back_right:  'In fondo A destra',
                front_left:  'Davanti A sinistra',
                front_right: 'Davanti A destra',
            },

        },
        stepFour: {
            menu: {
                title: 'Rivestimenti',
                sheight:  'Altezza di rivestimento:',
                body:  {
                    len:   '1',
                    1:     'Foro per miscelatore monocomando davanti a destra',
                    back:  'in fondo',
                    front: 'davanti',
                    left:  'a sinistra',
                    right: 'a destra',
                },
            },
            form: {
                title:    'Codice rivestimenti:',
                checkbox: 'Rivestimento ridotto',
                sheight:  'Altezza di rivestimento (cm):',
                left:     'A sinistra',
                right:    'A destra',
                back:     'In fondo',
                front:    'Davanti',
            },
            summary: {
                S23: {
                    '1':  "Rivestimento in fondo",
                    '02': "Rivestimento ridotto in fondo a sinistra",
                    '03': "Rivestimento ridotto in fondo a destra"
                },
                S45: {
                    '1':  "Rivestimento a destra",
                    '04': "Rivestimento ridotto a destra in fondo",
                    '05': "Rivestimento ridotto a destra davanti"
                },
                S67: {
                    '1':  "Rivestimento davanti",
                    '06': "Rivestimento ridotto davanti a destra",
                    '07': "Rivestimento ridotto davanti a sinistra"
                },
                S81: {
                    '1':  "Rivestimento a sinistra",
                    '01': "Rivestimento ridotto a sinistra in fondo",
                    '08': "Rivestimento ridotto a sinistra davanti"
                }
            }
        },
        stepFive: {
            menu: {
                title: 'Superficie',
                title2: 'Colore',
                body:  {
                    len:       '2',
                    1:         'bianco avorio',
                    2:         'CLEANEFFECT, GLASUR PLUS',
                    antigliss: 'CLEANEFFECT',
                    glassur:   'GLASUR PLUS',
                    GT:        'CLEANEFFECT',
                    OV:        'GLASUR PLUS',
                },
            },
            form: {
                ober:           'TRATTAMENTO DELLA SUPERFICIE',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'CLEANEFFECT',
                txtPlaceholder: 'Commenti per richiesta speciale',
                colorName:      'Nome di colore',
                options:        [
                    'Nome di colore',
                ],
            },
        },

    },
    WT: {
        stepOne: {
            menu: {
                title: 'Su misura',
                body:  {
                    len: '2',
                    1:   'Dimensioni di base:',
                    2:   'Dimensioni effettive:',
                },
                left:  'Dimensione dell\'asse a sinistra:',
                front: 'Dimensione dell\'asse davanti:'
            },
            form: {
                title: 'Dimensioni di base',
                tiefe: 'PROFONDITÀ',
                width: 'LARGHEZZA',
                to:    'bis',
                left:  'DIM. ASSE SINISTRA',
                front: 'DIM. ASSE DAVANTI'
            },

        },
        stepTwo: {
            menu: {
                title: 'Fori speciali',
                body:  {
                    len:                      '2',
                    1:                        'Foro per rubinetteria, erogatore di sapone,',
                    2:                        'Distributore di salviette, presa di corrente',
                    MISSING_WT_ALAZ_CHECKBOX: 'Foro per rubinetteria',
                    MISSING_WT_ALAZ_checkbox: 'Foro per rubinetteria',
                    MISSING_WT_ALS_CHECKBOX:  'Foro speciale',
                    MISSING_WT_ALS_checkbox:  'Foro speciale',
                    MISSING_SSPV_checkbox:    'Dispenser di sapone',
                    SSPV:                     'Dispenser di sapone',
                    ST:                       'Presa di corrente',
                    HTH:                      'Portasciugamani',
                },
            },
            form: {
                armaturenloch:            'Con foro per rubinetteria',
                armatur:                  'Foro per rubinetteria',
                MISSING_WT_ALAZ_CHECKBOX: 'Foro per rubinetteria',
                MISSING_WT_ALAZ_checkbox: 'Foro per rubinetteria',
                MISSING_WT_ALS_CHECKBOX:  'Foro speciale',
                MISSING_WT_ALS_checkbox:  'Foro speciale',
                MISSING_SSPV_checkbox:    'Dispenser di sapone',
                SSPV:                     'Dispenser di sapone',
                ST:                       'Presa di corrente',
                HTH:                      'Portasciugamani',
                position:                 'Posizione foro per rubinetteria',
                specialHole:              'Foro speciale',
                loch3:                    'Miscelatore tre fori',
                description:              'Descrizione',
                drawing:                  'CARICARE DISEGNO',
                soapDispenser:            'Foro per dispenser di sapone',
                socket:                   'Foro per presa di corrente',
                towerHolder:              'Foro per portasciugamani',
                left:                     'a sinistra',
                S:                        'S',
                A:                        'A',
            },

        },
        stepThree: {
            menu: {
                title: 'Altri opzioni',
                body:  {
                    len:  '2',
                    1:    'Distributore di salviette',
                    2:    'Senza troppopieno',
                    UL:   'Senza troppopieno',
                    UL_inverter:   'Senza troppopieno',
                    KTSV: 'Distributore di salviette',
                    MISSING_KTSV_checkbox: 'Distributore di salviette',
                },
            },
            form: {
                tissueDispensers: 'Distributore di salviette',
                UL:               'Senza troppopieno',
                KTSV:             'Distributore di salviette',
                position:         'Posizione',
                withoutOverflow:  'Senza troppopieno',
                above_left:       'In fondo a sinistra',
                above_right:      'In fondo a destra',
                bellow_left:      'Davanti a sinistra',
                bellow_right:     'Davanti a destra',
                text_field: {
                    placeholder: 'Commenti per richiesta speciale',
                },
            },

        },
        stepFour: {
            menu: {
                title: 'Superficie',
                title2: 'Colore',
                body:  {
                    len:       '2',
                    1:         'bianco mat',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'ANTIGLISS PRO',
                    OV:        'CLEANEFFECT',
                },
            },
            form: {
                ober:           'TRATTAMENTO DELLA SUPERFICIE',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'CLEANEFFECT',
                txtPlaceholder: 'Commenti per richiesta speciale',
                colorName:      'Nome di colore',
                options:        [
                    'Nome di colore',
                ],
            },


        },
    },
    KRW: {
        stepOne: {
            menu: {
                title: 'Su misura',
                body:  {
                    len: '2',
                    1:   'Dimensioni di base:',
                    2:   'Dimensioni effettive:',
                },
            },
            form: {
                title:  'Dimensioni effettive',
                width:  'LARGHEZZA (CM)',
                length: 'LUNGHEZZA (CM)',
                to:     'a',
            },

        },
        stepTwo: {
            menu: {
                title: 'Bordi visibili',
                body:  {
                    len:   '2',
                    1:     'Codice bordi',
                    back:  'sopra',
                    front: 'sotto',
                    left:  'a sinistra',
                    right: 'a destra',
                },
            },
            form: {
                title:    'Codice bordi:',
                checkbox: 'Teilzarge',
                back:  'Sopra',
                front: 'Sotto',
                left:  'A sinistra',
                right: 'A destra',
            },
            summary: {
                SK23: {
                    '1':  " · bordo visibile sopra"
                },
                SK45: {
                    '1':  " · bordo visibile a destra"
                },
                SK67: {
                    '1':  " · bordo visibile sotto"
                },
                SK81: {
                    '1':  " · bordo visibile a sinistra"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Prese',
                title2: 'Prese',
                type: 'Tipo di presa',
                socket: 'Presa',
                body:  {
                    ST1: 'Presa 1',
                    ST2: 'Presa 2',
                    ST3: 'Presa 3',
                    ST4: 'Presa 4',
                    ST5: 'Presa 5',
                },
            },
            form: {
                type: 'Tipo die presa',
                socket: 'Presa',
                position_x: 'Posizione horizontale (cm)',
                position_y: 'Posizione verticale (cm)',
            },

        },
        stepFour: {
            menu: {
                title: 'Ritagli rettangolari',
                body:  {
                    AS1: '(1)',
                    AS2: '(2)',
                    AS3: '(3)',
                    AS4: '(4)',
                    AS5: '(5)',
                },
                summary:  {
                    AS1: 'Ritaglio 1',
                    AS2: 'Ritaglio 2',
                    AS3: 'Ritaglio 3',
                    AS4: 'Ritaglio 4',
                    AS5: 'Ritaglio 5',
                },
            },
            form: {
                title: 'Ritagli',
                position_x: 'Posizione horizontale (cm)',
                position_y: 'Posizione verticale (cm)',
                size_x: 'Misura horizontale (cm)',
                size_y: 'Misura verticale (cm)',
            },

        },
        stepFive: {
            menu: {
                title: 'Ritagli rotondi',
                body:  {
                    ASR1: '(1)',
                    ASR2: '(2)',
                    ASR3: '(3)',
                    ASR4: '(4)',
                    ASR5: '(5)',
                },
                summary:  {
                    ASR1: 'Ritaglio rotondo 1',
                    ASR2: 'Ritaglio rotondo 2',
                    ASR3: 'Ritaglio rotondo 3',
                    ASR4: 'Ritaglio rotondo 4',
                    ASR5: 'Ritaglio rotondo 5',
                },
            },
            form: {
                title: 'Ritaglio',
                measure: 'Diametro (cm)',
                position_x: 'Posizione horizontale (cm)',
                position_y: 'Posizione verticale (cm)'
            },

        },
        stepSix: {
            menu: {
                title: 'Bordo curvo',
                body:  {
                    GK45: 'Bordo curvo a destra',
                    GK81: 'Bordo curvo a sinistra',
                },
            },
            form: {
                measure: 'Misura in (cm)',
                left: 'A destra',
                right: 'A sinistra',
            },

        },
        stepSeven: {
            menu: {
                title: 'Superfice',
                title2: 'Colore',
                body:  {
                    len:  '2',
                    OV:  'CLEANEFFECT',
                },
            },
            form: {
                ober:           'TRATTAMENTO DELLA SUPERFICIE',
                glazePlus:      'GLASUR PLUS',
                antiglissPro:   'CLEANEFFECT',
                txtPlaceholder: 'Commenti per richiesta speciale',
                colorName:      'Nome di colore',
                options:        [
                    'Nome di colore',
                ],
            },

        },
    },
    previous:           'INDIETRO',
    next:               'AVANTI',
    downloadAndContact: {
        title:             'DOWNLOAD E CONTATTI',
        configurationCode: 'Codice di configurazione:',
        schmidlinArtNo:    'No articolo:',
        SGNr:              'SGVSB-Nr.:',
        stNr:              'Numero SGVSB:',
        recommended:       'Raccomandato',
        salesPrice:        'Prezzo brutto',
        totalPrice:        'Totale',
        inquireQuotation:  'SOMMARIO',
        order:             'ORDINARE',
        contactDealer:     'CONTATTARE RIVENDITORE',
    },
    currencyCHF: 'CHF',
    BREADCRUMBS: {
        sortiment:   'GAMMA',
        model:       'MODELLO',
        bathtub:     'VASCHE DA BAGNO',
        wt:          'LAVABO',
        dwdf:        'PIATTI DOCCIA',
        showerTrays: 'PIATTI E SUPERFICI DOCCIA',
        washbasins:  'LAVABO',
        urinals:     'ORINATOI',
    },
    showPrices: 'Presentare prezzi',
    hidePrices: 'Celare prezzi',
}



// WEBPACK FOOTER //
// ./src/translations/italian.js